var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUsersMedical = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "users-medical",
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.842,
    height: 39.873,
    viewBox: "0 0 49.842 39.873",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4498",
    "data-name": "Path 4498",
    d: "M454.23,320a1.25,1.25,0,0,0-1.246,1.246v3.738h-3.738A1.25,1.25,0,0,0,448,326.23v2.492a1.25,1.25,0,0,0,1.246,1.246h3.738v3.738a1.25,1.25,0,0,0,1.246,1.246h2.492a1.25,1.25,0,0,0,1.246-1.246v-3.738h3.738a1.25,1.25,0,0,0,1.246-1.246V326.23a1.25,1.25,0,0,0-1.246-1.246h-3.738v-3.738A1.25,1.25,0,0,0,456.722,320Z",
    transform: "translate(-413.111 -295.079)",
    fill: "#888",
    opacity: 0.402
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4499",
    "data-name": "Path 4499",
    d: "M4.984,6.23a6.23,6.23,0,1,1,6.23,6.23,6.23,6.23,0,0,1-6.23-6.23Zm28.659,0a6.23,6.23,0,1,1,6.23,6.23,6.23,6.23,0,0,1-6.23-6.23ZM8.31,14.952h3.325a8.354,8.354,0,0,1,3.473.755,9.8,9.8,0,0,0-.148,1.737,9.972,9.972,0,0,0,3.372,7.476H1.659A1.665,1.665,0,0,1,0,23.262,8.312,8.312,0,0,1,8.31,14.952Zm23.208,9.968a9.944,9.944,0,0,0,3.372-7.476,10.666,10.666,0,0,0-.148-1.737,8.234,8.234,0,0,1,3.473-.755H41.54a8.311,8.311,0,0,1,8.3,8.31,1.66,1.66,0,0,1-1.659,1.659H47.139a3.748,3.748,0,0,0-3.528-2.492H41.119a3.748,3.748,0,0,0-3.528,2.492H31.517Zm2.2,3.388A3.709,3.709,0,0,0,32.4,31.151v2.492a3.739,3.739,0,0,0,3.738,3.738h1.246v1.246a3.873,3.873,0,0,0,.21,1.246H12.048a2.079,2.079,0,0,1-2.079-2.079A10.383,10.383,0,0,1,20.349,27.413h9.143A10.33,10.33,0,0,1,33.713,28.308ZM24.921,9.968a7.476,7.476,0,1,1-7.476,7.476,7.476,7.476,0,0,1,7.476-7.476Z",
    fill: "#0d47a1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUsersMedical);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/users-medical.a8ff9ec4386b9d223680c63ba469b8c6.svg";